function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 2H3C2.44771 2 2 2.44772 2 3V17C2 17.5523 2.44772 18 3 18H8C8.55228 18 9 17.5523 9 17C9 16.4477 9.44771 16 10 16C10.5523 16 11 16.4477 11 17C11 18.6569 9.65685 20 8 20H3C1.34315 20 0 18.6569 0 17V3C0 1.34315 1.34315 0 3 0H8C9.65685 0 11 1.34315 11 3C11 3.55228 10.5523 4 10 4C9.44771 4 9 3.55228 9 3C9 2.44772 8.55229 2 8 2ZM15.2 6.6C14.8686 6.15817 14.9582 5.53137 15.4 5.2C15.8418 4.86863 16.4686 4.95817 16.8 5.4L19.8 9.4C20.0667 9.75555 20.0667 10.2444 19.8 10.6L16.8 14.6C16.4686 15.0418 15.8418 15.1314 15.4 14.8C14.9582 14.4686 14.8686 13.8418 15.2 13.4L17 11H9C8.44771 11 8 10.5523 8 10C8 9.44771 8.44771 9 9 9H17L15.2 6.6Z",
  fill: "white"
});

var SvgLogOut = function SvgLogOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logOut.6d0ded1c.svg";
export { ForwardRef as ReactComponent };